export const WINDOW_STATE_KEY = "WINDOW_STATE";

export const getOpenWindows = (state: Record<string, any>): string[] => {
    return [...state[WINDOW_STATE_KEY].open.keys()];
};
